module.exports = __webpack_public_path__ + "static/img/smile1.5e2d41a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smile1.png
// module id = I3di
// module chunks = 2